import PropTypes from 'prop-types';
import React from 'react';
import { Dropdown, MenuItem } from 'react-bootstrap';
import {
  ArrowLeft,
  CircleX,
  Copy,
  Ellipsis,
  Lock,
  LockOpen,
  Pencil,
  RotateCw,
} from 'lucide-react';

import styles from './JobHeader.module.scss';
import StatusBadge from 'components/ClientATS/StatusBadge/StatusBadge';

const JobHeader = ({
  briefTitle,
  briefStatus,
  postedDate,
  isPrivate,
  isClosed,
  showJobMenu,
  onToggleMenu,
  onEditJob,
  onDuplicateJob,
  onCloseJob,
  onReopenJob,
  onTogglePrivate,
}) => {
  return (
    <div className={styles.header}>
      <div>
        <div className={styles.backLink}>
          <a className={styles.backButton} href="/ats">
            <ArrowLeft width={16} height={16} />
            <span>Back to Dashboard</span>
          </a>
        </div>

        <div className={styles.titleSection}>
          <div className={styles.titleWrapper}>
            <div className={styles.statusBadgeWrapper}>
              <StatusBadge
                status={briefStatus}
                className={styles.statusBadgeMobile}
              />
              {isPrivate && (
                <StatusBadge
                  status="private"
                  className={styles.statusBadgeMobile}
                />
              )}
            </div>
            <div className={styles.titleContent}>
              <h3 className={styles.title}>{briefTitle}</h3>
              <StatusBadge
                status={briefStatus}
                className={styles.statusBadgeDesktop}
              />
              {isPrivate && (
                <StatusBadge
                  status="private"
                  className={styles.statusBadgeDesktop}
                />
              )}
            </div>
            <p className={styles.postedDate}>Posted {postedDate}</p>
          </div>
          <Dropdown
            id="job-menu-dropdown"
            pullRight
            open={showJobMenu}
            onToggle={onToggleMenu}
          >
            <Dropdown.Toggle noCaret className={styles.jobMenuButton}>
              <Ellipsis width={24} height={24} />
            </Dropdown.Toggle>
            <Dropdown.Menu className={styles.jobMenuDropdown}>
              <MenuItem onClick={onEditJob}>
                <Pencil width={16} height={16} />
                Edit Job
              </MenuItem>
              <MenuItem onClick={onDuplicateJob}>
                <Copy width={16} height={16} />
                Duplicate Job
              </MenuItem>
              {isClosed ? (
                <MenuItem onClick={onReopenJob}>
                  <RotateCw width={16} height={16} />
                  Re-open Job
                </MenuItem>
              ) : (
                <MenuItem onClick={onCloseJob}>
                  <CircleX width={16} height={16} />
                  Close Job
                </MenuItem>
              )}
              {isPrivate ? (
                <MenuItem onClick={onTogglePrivate}>
                  <LockOpen width={16} height={16} />
                  Make Public
                </MenuItem>
              ) : (
                <MenuItem onClick={onTogglePrivate}>
                  <Lock width={16} height={16} />
                  Make Private
                </MenuItem>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

JobHeader.propTypes = {
  briefTitle: PropTypes.string.isRequired,
  briefStatus: PropTypes.string.isRequired,
  postedDate: PropTypes.string.isRequired,
  isPrivate: PropTypes.bool.isRequired,
  isClosed: PropTypes.bool.isRequired,
  showJobMenu: PropTypes.bool.isRequired,
  onToggleMenu: PropTypes.func.isRequired,
  onEditJob: PropTypes.func.isRequired,
  onDuplicateJob: PropTypes.func.isRequired,
  onCloseJob: PropTypes.func.isRequired,
  onReopenJob: PropTypes.func.isRequired,
  onTogglePrivate: PropTypes.func.isRequired,
};

export default JobHeader;
